<script>
	// From Lucide
	import { ChevronLast } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ChevronLast class={iconClass} />
